import { useContext } from 'react';

import { PlaybackEnum } from '../core/ui/enums/PlaybackEnum';
import PlayerContext from '../pages/playground/playerContext/PlayerContext';

export function useIsPlaying() {
  const contextValue = useContext(PlayerContext);
  return contextValue.isPlaying === PlaybackEnum.PLAYING;
}
